import { render } from "./BaseSectionTitle.vue?vue&type=template&id=fa0fc434&scoped=true"
import script from "./BaseSectionTitle.vue?vue&type=script&lang=js"
export * from "./BaseSectionTitle.vue?vue&type=script&lang=js"

import "./BaseSectionTitle.vue?vue&type=style&index=0&id=fa0fc434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0fc434"]])

export default __exports__